import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";
import type { ColumnSuggestionsStorage } from "./types";

export default function createColumnSuggestionsCommonStorage(storageProvider: ModuleStorage): ColumnSuggestionsStorage {
    const NOTIFICATION_SEEN_STORAGE_KEY = "is-notification-seen";

    return {
        getIsNotificationSeen(): boolean {
            return storageProvider.retrieve(NOTIFICATION_SEEN_STORAGE_KEY) as boolean;
        },
        setIsNotificationSeen(isSeen: boolean): void {
            return storageProvider.persist(NOTIFICATION_SEEN_STORAGE_KEY, isSeen);
        },
    };
}
